import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import charts_template from '~/templates/charts.handlebars';
import getReportSubCategoryService from '~/services/reportSubCategoryService';
import GeneralView from '~/generalView';
import svgAsPngUri from 'svgAsPngUri';
import c3 from 'c3';
import d3 from 'd3';
import chartService from '~/services/chartService';
var AdminCategoriesView = GeneralView.View.extend({
	tagName: "div",
	className: 'chartviewcontainer',
	filters: {},
	reports: [],
	reportsfiltered: [],
	informdate1: '',
	informdate2: '',
	allsupercategories : [],
	allsubcategories : [],
	months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Setiembre","Octubre", "Noviembre","Diciembre"],
	days: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
	monthsShortNotation: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
	monthsNamesKeys: ['January','February','March','April','May','June','July','August','September','October','November','December'],
	monthsBasicObject: {x: {type: 'category', categories: []}},
	general: true,
	events: {
		'click #downloadpdf' : 'downloadpdf',
		'click #downloadexcel' : 'exportable',
		'click #downloadexcelreports' : 'createreporttable',
	},
	
	downloadpdf: function(){
		var that =this;
		this.$el.find('#downloadpdf').hide();
		this.$el.find('.loader').show();
		var images = document.getElementsByTagName("svg");
		d3.selectAll(".c3-axis path").style({ 'fill':'none', 'stroke': '#000' });
		var doc = new jsPDF()
		var date1 = new Date();
		var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
		var options2 = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		var xx1 = date1.toLocaleDateString(lang+'-GB',options);var xx2 = date1.toLocaleDateString(lang+'-GB',options2);
		doc.text(arrlang[lang]['Charttittle'], 90, 20);
		svgAsPngUri(images[0], {}, function(uri) {
			doc.text(xx2, 75,30);
			var xx3 = $('#subtittle').text();
			if(xx3.length > 30){
				doc.text(xx3, 30,40);
			}
			else{
				doc.text(xx3, 75,40);
			}
			doc.addImage(uri,10,60,190,50);
			$('.loader').hide();
			$("#downloadpdf").fadeIn();
			doc.save(xx1+'.pdf');
			Parse.Cloud.run("creategraphs", {"type": "pdfchart", "filters":that.filters}).then(function(result) {
				
			},
			function(error){
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		});
	},
	
	render: function () {
		var that = this;
		var handlebarsTemplate = Handlebars.template(charts_template);
		this.$el.html(handlebarsTemplate());
		this.listenTo(EventHub, 'dataforchart', querystring => {
			if (querystring) {
				that.general = false;
				if (querystring.slice(0,15) == 'supercategories') {
					var lenghtv = querystring.length;
					var supcatcont = querystring.slice(15,lenghtv);
					var arrsupcats = supcatcont.split(",");
					var date1 = new Date();
					var date2 = new Date();
					date1.setMonth(date1.getMonth() -5);
					date2.setMonth(date2.getMonth() +1);
					this.getcustomreports('Months','SuperCategories',date1,date2,arrsupcats);
				}
				if (querystring.slice(0,13) == 'subcategories') {
					var lenghtv = querystring.length;
					var supcatcont = querystring.slice(13,lenghtv);
					var arrsupcats = supcatcont.split(",");
					var date1 = new Date();
					var date2 = new Date();
					date1.setMonth(date1.getMonth() -5);
					date2.setMonth(date2.getMonth() +1);
					this.getcustomreports('Months','SubCategories',date1,date2,arrsupcats);
				}
				var lenghtv = querystring.length;
				if (querystring.charAt(5) == '-') {
					var pos = querystring.indexOf("!")+1;
					if( querystring.includes("$")){
						var pos = querystring.indexOf("$")+1;
					}
					var supcatcont = querystring.slice(pos,lenghtv);
					var arrsupcats = supcatcont.split(",");
					var syear1 = querystring.slice(0,4);
					var syear2 = querystring.slice(7,11);
					this.$el.find('#subtittle').text(arrlang[lang]['YearsRange']+' '+syear1 + ' - '+syear2);
					if (querystring.charAt(11) == '!') {
						this.getcustomreports('Years','SuperCategories',syear1,syear2,arrsupcats);
					}
					if (querystring.charAt(11) == '$') {
						this.getcustomreports('Years','SubCategories',syear1,syear2,arrsupcats);
					}
					if (querystring.charAt(11) != '$' && querystring.charAt(11) != '!' ){
						var arrsupcats = [0];
						this.getcustomreports('Years','General',syear1,syear2,arrsupcats);
					}
				}
				if (querystring.charAt(1) == '-') {
					var pos = querystring.indexOf("!")+1;
					if( querystring.includes("$")){
						var pos = querystring.indexOf("$")+1;
					}
					var supcatcont = querystring.slice(pos,lenghtv);
					var arrsupcats = supcatcont.split(",");
					var x1 = querystring.slice(0,1);
					var x2 = querystring.slice(2,3);
					var dates = [];
					for (var i = 6; i >= 0; i--) {
						dates[i] = new Date();
						dates[i].setDate(dates[i].getDate()-i);
					}
					var datepicked1 = new Date(), datepicked2 = new Date();
					for (var i = 0; i < dates.length; i++) {
						if (dates[i].getDay() == x1) {
							datepicked1 = dates[i];
						}
						if (dates[i].getDay() == x2) {
							datepicked2 = dates[i];
						}
					}
					var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
					var xx1 = datepicked1.toLocaleDateString(lang+'-GB',options);var xx2 = datepicked2.toLocaleDateString(lang+'-GB',options);
					this.$el.find('#subtittle').text(xx1+' - '+xx2);
					if (querystring.charAt(3) == '!') {
						this.getcustomreports('Days','SuperCategories',datepicked1,datepicked2,arrsupcats);
					}
					if (querystring.charAt(3) == '$') {
						this.getcustomreports('Days','SubCategories',datepicked1,datepicked2,arrsupcats);
					}
					if (querystring.charAt(3) != '!' && querystring.charAt(3) != '$'){
						var arrsupcats = [0];
						this.getcustomreports('Days','General',datepicked1,datepicked2,arrsupcats);
					}
				}
				if (querystring.charAt(9) == '-') {
					var pos = querystring.indexOf("!")+1;
					if( querystring.includes("$")){
						var pos = querystring.indexOf("$")+1;
					}
					var supcatcont = querystring.slice(pos,lenghtv);
					var arrsupcats = supcatcont.split(",");
					var month1 = querystring.slice(0,3);
					var month2 = querystring.slice(11,14);
					var year1 = querystring.slice(4,8);
					var year2 = querystring.slice(15,19);
					var month1num = 0;
					var month2num = 0;
					for(var j=0; j<that.monthsShortNotation.length;++j){
						if (month1 == that.monthsShortNotation[j]){
							month1num = j;
						}
						if (month2 == that.monthsShortNotation[j]){
							month2num = j;
						}
					}
					var date1 = new Date(year1,month1num,1, 0, 0, 1, 0);
					var date2 = new Date(year2,month2num+1,1, 0, 0, 1, 0);
					this.$el.find('#subtittle').text(arrlang[lang]['Monthrange']+' '+ arrlang[lang][this.monthsNamesKeys[month1num]] +' - '+arrlang[lang][this.monthsNamesKeys[month2num]]);
					if (querystring.charAt(19) == '!') {
						this.getcustomreports('Months','SuperCategories',date1,date2,arrsupcats);
					}
					if (querystring.charAt(19) == '$') {
						this.getcustomreports('Months','SubCategories',date1,date2,arrsupcats);
					}
					if (querystring.charAt(19) != '$' && querystring.charAt(19) != '!'){
						var arrsupcats = [0];
						this.getcustomreports('Months','General',date1,date2,arrsupcats);
					}
				}
			}
			else{
				var date1 = new Date();
				var date2 = new Date();
				date1.setMonth(date1.getMonth() -5);
				date2.setMonth(date2.getMonth() +1);
				var arrsupcats = [0];
				this.getcustomreports('Months','General',date1,date2,arrsupcats);
			}
		});
		this.translate();
		return this;
	},
	
	getcustomreports: function(type,kind,date1,date2,arrsupcats){
		var that = this;
		that.filters.type=type;
		that.filters.kind=kind;
		that.filters.date1=date1;
		that.filters.date2=date2;
		that.filters.arrsupcats=arrsupcats;
		Parse.Cloud.run("GetallDbReports").then(function(data) {
			Parse.Cloud.run("getsupercategories").then(function(result) {
				var subCategoryPromise = getReportSubCategoryService().fetch({all: true,cache: false,rules: {active: true}});
				Parse.Promise.when(subCategoryPromise).then((subcategories) => {
					that.allsupercategories = result;
					that.allsubcategories = subcategories.models;
					that.reports = data;
					var selectedall = [];
					var superarrsupcat = [];
					var arrayforchart = that.monthsBasicObject;
					arrayforchart.x.categories = [];
					var monthsarray = [];
					var daysarray = [];
					var generalcounter = [];
					if (type == 'Days') {
						var day = date1.getDay();
						for(var i = 0; i <= 7; i++){
							daysarray.push(day);
							if (day == date2.getDay()) {break;}
							day = (day+1) % 7;
						}
						for (var i = 0; i < daysarray.length; i++) {
							arrayforchart.x.categories.push(that.days[daysarray[i]]);
							generalcounter.push(0);
						}
					}
					if (type =='Years') {
						for (var i = parseInt(date1) ; i <= date2; i++) {
							generalcounter.push(0);
							arrayforchart.x.categories.push(i);
						}
					}
					if (type == 'Months') {
						var selectedmonth1 = date1.getMonth();
						var selectedmonth2 = date2.getMonth();
						var n = selectedmonth1;
						for (var i = 0; i < 12; i++) {
							monthsarray.push(n);
							n = (n+1) % 12;
							if (n == selectedmonth2) {break;}
						}
						for (var i = 0; i < monthsarray.length; i++) {
							arrayforchart.x.categories.push(that.months[monthsarray[i]]);
							generalcounter.push(0);
						}
					}
					for (var xx = 0; xx < arrsupcats.length; xx++) {
						var supercatname = '';
						for (var i = 0; i < generalcounter.length; i++) {
							generalcounter[i] = 0;
						}
						for (var i = 0; i < that.reports.length; i++) {
							var condition = false;
							switch (kind) {
								case 'SubCategories':
									condition = that.reports[i].attributes.subCategory.id == arrsupcats[xx];
									selectedall = that.allsubcategories;
								break;
								case 'SuperCategories':
									selectedall = that.allsupercategories;
									if(that.reports[i].attributes.subCategory.attributes.superCat != undefined){
										condition =that.reports[i].attributes.subCategory.attributes.superCat.id == arrsupcats[xx];
									}
								break;
								case 'General':
									condition = true;
								break;
								default:
									
								break;
							}
							if (condition) {
								if(kind != 'General'){
									supercatname = that.reports[i].attributes.subCategory.attributes.name;
									if (kind == 'SuperCategories'){ 
										supercatname = that.reports[i].attributes.subCategory.attributes.superCat.attributes.name;
									}
								}
								if(kind == 'General'){
									supercatname = arrlang[lang]["QuantReports"];
								}
								var x = that.reports[i].attributes.createdAt;
								if(type == 'Months'){
									if(x > date1 && x <= date2){
										if (x.getFullYear() <= date2.getFullYear() && x.getFullYear() >= date1.getFullYear() ) {
											for (var k = 0; k < monthsarray.length; k++) {
												if(x.getMonth() == monthsarray[k]){
													generalcounter[k]++;
												}
											}
										}
									}
								}
								if (type == 'Years') {
									for(var j = 0; j <  arrayforchart.x.categories.length; j++){
										if(x.getFullYear() ==  arrayforchart.x.categories[j]){
											generalcounter[j]++;
										}
									}
								}
								if (type == 'Days') {
									if(x >= date1 && x <= date2){
										for (var g = 0; g < daysarray.length; g++) {
											if(x.getDay() == daysarray[g]){
												generalcounter[g]++;
											}
										}
									}
								}
							}
						}
						var dataarray = [];
						if (supercatname == "") {
							for (var i = 0; i < selectedall.length; i++) {
								if(selectedall[i].id == arrsupcats[xx]){
									supercatname = selectedall[i].attributes.name;
								}
							}  
						}
						dataarray.push(supercatname);
						dataarray = dataarray.concat(generalcounter);
						superarrsupcat.push(dataarray)
					}
					if(kind == 'General'){
						that.renderresults(arrayforchart,dataarray,1);
					}
					if(kind != 'General'){
						that.renderresults(arrayforchart,superarrsupcat,2);
					}
					that.createtable(type,kind,date1,date2,arrsupcats);
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			function(error) {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		function(error) {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	renderresults: function(months,dataarray,bol){
		c3.generate(chartService.getChartConfig(months,dataarray,bol));
		$("#downloadpdf").fadeIn();
		$("#chartgraphloader").hide();
	},
	
	createtable: function(type,kind,date1,date2,arrsupcats){
		var that = this;
		that.reportsfiltered = []; 
		var tr = 0;
		$('.maininfo-table').empty();
		$('.maininfo-table').append('<tr class=""><td align="center" colspan="6" class=" tabledate" style="display: none"></td></tr><tr><th class="infotableheadernone "></th><th class="infotableheader infotableheader2 item" key="tableheadernew">Reportes Abiertos</th> <th class="infotableheader infotableheader3 item" key="tableheaderclosed">Reportes Cerrados</th><th class="infotableheader infotableheader4 item" key="tableheaderdiscard">Reportes Descartados</th><th class="infotableheader infotableheader5 item" key="tableheaderassigned">Resultados Totales</th></tr>');
		if (type == 'Years') {
			date1 = new Date(date1, 0, 1);
			date2 = new Date(date2, 11, 31);
		}
		var selectedall = [];
		var totalresults =[arrlang[lang]["allcategories"],0,0,0,0,0];
		var docustomreportchart = 0;
		for (var xx = 0; xx < arrsupcats.length; xx++) {
			var results =['',0,0,0,0,0];
			for (var i = 0; i < that.reports.length; i++) {
				var condition = false;
				switch (kind) {
					case 'SubCategories':
						selectedall = that.allsubcategories;
						condition = that.reports[i].attributes.subCategory.id == arrsupcats[xx];
					break;
					case 'SuperCategories':
						selectedall = that.allsupercategories;
						if(that.reports[i].attributes.subCategory.attributes.superCat != undefined){
							condition =that.reports[i].attributes.subCategory.attributes.superCat.id == arrsupcats[xx];
						}
					break;
					case 'General':
						condition = true;
					break;
					default:
						
					break;
				}
				if (condition) {
					if(kind != 'General'){
						results[0] = that.reports[i].attributes.subCategory.attributes.name;
						if(that.reports[i].attributes.customreportvalues != undefined && docustomreportchart == 0){
							for (var j = 0; j < that.reports[i].attributes.customreportvalues.customdata.length; j++) {
								if(that.reports[i].attributes.customreportvalues.customdata[j].type != 'file' && kind == 'SubCategories'){
									$('#headersfortable').append('<th class="infotableheader item" key="tableadminnotes">'+that.reports[i].attributes.customreportvalues.customdata[j].name+'</th>');
								}
							}
							docustomreportchart = 1;
						}
						if (kind == 'SuperCategories'){
							results[0] = that.reports[i].attributes.subCategory.attributes.superCat.attributes.name;
						}
					}
					if(kind == 'General'){
						results[0] = arrlang[lang]["generaltable"];
					}
					var x = that.reports[i].attributes.createdAt;
					if(x > date1 && x <= date2){
						if (that.reports[i].attributes.status == "open") {
							results[1]++;
						}
						if (that.reports[i].attributes.status == "close") {
							results[2]++;
						}
						if (that.reports[i].attributes.status == "discard") {
							results[3]++;
						}
						that.reportsfiltered.push(that.reports[i].id);
					}
				}
			}
			results[4] = results[1] + results[2] + results[3];
			totalresults[1] = results[1] + totalresults[1];
			totalresults[2] = results[2] + totalresults[2];
			totalresults[3] = results[3] + totalresults[3];
			totalresults[4]= totalresults[1] + totalresults[2] + totalresults[3];
			if (results[0] == '') {
				for (var i = 0; i < selectedall.length; i++) {
					if(selectedall[i].id == arrsupcats[xx]){
						results[0] = selectedall[i].attributes.name;
					}
				}     
			}
			$('.maininfo-table').append('<tr><td class="infotabledata">'+results[0]+'</td><td class="infotabledata infotabledata2">'+results[1]+'</td><td class="infotabledata infotabledata3">'+results[2]+'</td><td class="infotabledata infotabledata2">'+results[3]+'</td><td class="infotabledata infotabledata3">'+results[4]+'</td></tr>');
		}
		if (type == "Days") {
			var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			var xx1 = date1.toLocaleDateString(lang+'-GB',options);
			var xx2 = date2.toLocaleDateString(lang+'-GB',options);
		}
		if (type == 'Years') {
			var xx1 = date1.getFullYear();
			var xx2 = date2.getFullYear();
		}
		if (type == 'Months') {
			var xx1 = arrlang[lang][that.monthsNamesKeys[date1.getMonth()]];
			var xx2 = arrlang[lang][that.monthsNamesKeys[date2.getMonth()-1]];
			if (date2.getMonth() == 0) {
				var xx2 = arrlang[lang][that.monthsNamesKeys[11]]
			}
		}
		this.informdate1 = xx1;
		this.informdate2 = xx2;
		$('.tabledate').show();
		$('.tabledate').text(arrlang[lang]['ShogunInform']+' '+xx1 + ' - '+xx2);
		$('.chartmsg').show();
		if(kind != 'General'){
			$('.maininfo-table').append('<tr><td class="infotabledata resultsallcategories">'+totalresults[0]+'</td><td class="infotabledata infotabledata2 resultsallcategories">'+totalresults[1]+'</td><td class="infotabledata infotabledata3 resultsallcategories">'+totalresults[2]+'</td><td class="infotabledata infotabledata2 resultsallcategories">'+totalresults[3]+'</td><td class="infotabledata infotabledata3 resultsallcategories">'+totalresults[4]+'</td></tr>');
			$('.chartmsg').hide();
		}
		$(".maininfo-table").fadeIn();
		$("#downloadexcel").fadeIn();
		$("#downloadexcelreports").fadeIn();
	},
	
	createreporttable: function(){
		$('#downloadexcelreports').prop('disabled', true);
		if(this.general){
			toastr.options.timeOut = "10000";
			toastr.options.extendedTimeOut = "2000";
			this.toastrButtons(arrlang[lang]['AnalyticsPersonalizedFormsInfo'], 'info');
			toastr.options.timeOut = "5000";
			toastr.options.extendedTimeOut = "1000";
		}
		var that = this;
		$('.loader2').show();
		var tr = 0; 
		for (var i = 0; i < that.reportsfiltered.length; i++) {
			var id =  { reportID: that.reportsfiltered[i],mobile: false};
			Parse.Cloud.run("GetReportforexcell", id).then((reportinfo) => {
				if(reportinfo.report != undefined){
					var options = {year: 'numeric',month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'};
					var langdate = lang + "-GB";
					var datereport = reportinfo.report[0].attributes.createdAt.toLocaleString(langdate, options);
					var reportcomments = '';
					for (var ii = 0; ii < reportinfo.reportcomments.length; ii++) {
						if (reportinfo.reportcomments[ii].attributes.auditor != undefined) {
							reportcomments +=  'auditor: ' +reportinfo.reportcomments[ii].attributes.comment;
							if(ii < reportinfo.reportcomments.length-1){
								reportcomments += ',<br style="mso-data-placement:same-cell;" />';
							}
						}
						else{
							reportcomments +=  '' +arrlang[lang]['Anonreport']+ ':'+ reportinfo.reportcomments[ii].attributes.comment;
							if(ii < reportinfo.reportcomments.length-1){
								reportcomments += ',<br style="mso-data-placement:same-cell;" />';
							}
						}
					}
					var username = arrlang[lang]['Anonreport'];
					if (reportinfo.report[0].attributes.userName != "") {
						username = reportinfo.report[0].attributes.userName; 
					}        
					var reportstatus = '';
					var chekstatus = false;
					var dateofcloseordiscard = '';
					if (reportinfo.report[0].attributes.status != undefined) {
						reportstatus = arrlang[lang][reportinfo.report[0].attributes.status]; 
						chekstatus = true;
						if(reportinfo.report[0].attributes.status == 'close' || reportinfo.report[0].attributes.status == 'discard'){
							for (var i = 0; i < reportinfo.auditreport.length; i++) {
								if (reportinfo.auditreport[i].attributes.action == 'closereport' || reportinfo.auditreport[i].attributes.action == 'discardreport'   ) {
									dateofcloseordiscard = reportinfo.auditreport[i].attributes.createdAt.toLocaleString(langdate, options);
								}
								else{
									dateofcloseordiscard = '';
								}
								break; 
							}
						} 
					}
					var reasonchangestatus = '';
					if (chekstatus) { 
						if (reportinfo.reasonsofchangestatus[0] != undefined) {
							if( reportstatus != 'open'){
								reasonchangestatus = reportinfo.reasonsofchangestatus[0].attributes.reason ;
							}
						}
					}
					var reportcollaborators = '';
					for (var i = 0; i < reportinfo.collaborators.length; i++) {
						reportcollaborators = reportinfo.collaborators[i] + ', ' + reportcollaborators;
					}
					reportcollaborators = reportcollaborators.trim();
					var repcol = reportcollaborators.slice(0, reportcollaborators.length - 1);
					var reportpriority = '';
					if (reportinfo.report[0].attributes.priority != undefined) {
						reportpriority = reportinfo.report[0].attributes.priority;
					}
					var reportdescription = '';
					var customreportdescription = '';
					if (reportinfo.report[0].attributes.description != undefined) {
						reportdescription = reportinfo.report[0].attributes.description;
					}
					if(reportinfo.report[0].attributes.customreportvalues != undefined){
						for (var j = 0; j < reportinfo.report[0].attributes.customreportvalues.customdata.length; j++) {
							if (reportinfo.report[0].attributes.customreportvalues.customdata[j] != undefined && reportinfo.report[0].attributes.customreportvalues.customdata[j].type != "file") {
								reportdescription +=  reportinfo.report[0].attributes.customreportvalues.customdata[j].name+": " + reportinfo.report[0].attributes.customreportvalues.customdata[j].val + ',<br style="mso-data-placement:same-cell;" />';
								if(this.filters.kind == 'SubCategories'){
									customreportdescription += '<td class="infotabledata">'+reportinfo.report[0].attributes.customreportvalues.customdata[j].val+'</td>'
									reportdescription = '';
								}
							}
						}
					}
					var reportcategory = reportinfo.report[0].attributes.subCategory.attributes.superCat.attributes.name;
					var reportsubcategory = reportinfo.report[0].attributes.subCategory.attributes.name;
					var adminnotes = '';
					for (var x = 0; x < reportinfo.adminnotes.length; x++) {
						if (reportinfo.adminnotes[x].attributes.auditor != undefined) {
							adminnotes += ''+ reportinfo.adminnotes[x].attributes.auditor.attributes.username +': '+ reportinfo.adminnotes[x].attributes.note;
							if(x < reportinfo.adminnotes.length-1){
								adminnotes += ',<br style="mso-data-placement:same-cell;" />';
							}
						}
						else{
							adminnotes += ''+ arrlang[lang]['DeletedUser'] +': '+ reportinfo.adminnotes[x].attributes.note;
							if(x < reportinfo.adminnotes.length-1){
								adminnotes += ',<br style="mso-data-placement:same-cell;" />';
							}
						}
					}
					var reportfirstresponse = '';
					if(reportinfo.reasonsofchangestatus[0]){
						reportfirstresponse = reportinfo.reasonsofchangestatus[0].attributes.createdAt.toLocaleString(langdate, options);
						if(reportinfo.reportcomments[0] && reportinfo.reportcomments[0].attributes.createdAt < reportinfo.reasonsofchangestatus[0].attributes.createdAt){
							reportfirstresponse = reportinfo.reportcomments[0].attributes.createdAt.toLocaleString(langdate, options);
						}
					}
					if(reportinfo.reportcomments[0]){
						reportfirstresponse = reportinfo.reportcomments[0].attributes.createdAt.toLocaleString(langdate, options);
						if(reportinfo.reasonsofchangestatus[0] && reportinfo.reasonsofchangestatus[0].attributes.createdAt < reportinfo.reportcomments[0].attributes.createdAt){
							reportfirstresponse = reportinfo.reasonsofchangestatus[0].attributes.createdAt.toLocaleString(langdate, options);
						}
					}
					if(this.filters.kind == 'SubCategories'){
						$('.reports-table').append('<tr><td class="infotabledata">'+reportinfo.report[0].id+'</td><td class="infotabledata">'+datereport+'</td><td class="infotabledata">'+reportcategory+'</td><td class="infotabledata">'+reportsubcategory+'</td><td class="infotabledata">'+username+'</td><td class="infotabledata">'+reportstatus+'</td><td class="infotabledata">'+reasonchangestatus+'</td><td class="infotabledata">'+dateofcloseordiscard+'</td><td class="infotabledata">'+repcol+'</td><td class="infotabledata">'+reportpriority+'</td><td class="infotabledata">'+reportcomments+'</td><td class="infotabledata">'+adminnotes+'</td><td class="infotabledata">'+reportdescription+'</td>'+customreportdescription+'</tr>');
					}
					else{
						$('.reports-table').append('<tr><td class="infotabledata">'+reportinfo.report[0].id+'</td><td class="infotabledata">'+datereport+'</td><td class="infotabledata">'+reportcategory+'</td><td class="infotabledata">'+reportsubcategory+'</td><td class="infotabledata">'+username+'</td><td class="infotabledata">'+reportfirstresponse+'</td><td class="infotabledata">'+reportstatus+'</td><td class="infotabledata">'+reasonchangestatus+'</td><td class="infotabledata">'+dateofcloseordiscard+'</td><td class="infotabledata">'+repcol+'</td><td class="infotabledata">'+reportpriority+'</td><td class="infotabledata">'+reportcomments+'</td><td class="infotabledata">'+adminnotes+'</td><td class="infotabledata">'+reportdescription+'</td></tr>');
					}
				}
				tr++; 
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			}).then(function() {     
				if (tr == that.reportsfiltered.length) {
					$('.loader2').hide();
					$('#downloadexcelreports').prop('disabled', false);
					var table = 'reportstable';
					that.exportable(table);
				}
			});
		}
	},
	
	exportable: function(tablename){
		var uri = 'data:application/vnd.ms-excel;base64,'
		, template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
		, base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
		, format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
		var table = tablename;
		if (tablename != "reportstable") {
			var table = "resultstable";
			Parse.Cloud.run("creategraphs", {"type": "excelresults",  "filters":this.filters}).then(function(result) {
				
			},
			function(error){
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		}
		if (tablename == "reportstable") {
			Parse.Cloud.run("creategraphs", {"type": "excelreports",  "filters":this.filters}).then(function(result) {
				
			},
			function(error){
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		}
		if (!table.nodeType) table = document.getElementById(table)
		var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
		var link = document.createElement("a");
		link.download = arrlang[lang]['Inform']+this.informdate1+"-"+this.informdate2+".xls";
		link.href = uri + base64(format(template, ctx));
		link.click();
	}
});
export default AdminCategoriesView;